var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(18.75 0.838) rotate(90)"},[React.createElement("path",{"d":"M0,17.505,18.687,4.923,26,0","fill":"none","stroke":"#5f3faa","strokeWidth":"3","key":0}),React.createElement("line",{"x1":"24","y1":"17.505","transform":"translate(24)","fill":"none","stroke":"#5f3faa","strokeWidth":"3","key":1})]));
}

Arrow.defaultProps = {"viewBox":"0 0 19.994 49.722"};

module.exports = Arrow;

Arrow.default = Arrow;
